// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__PT5DP","productName":"Table_productName__1pK3r"};